import type { SellerApplication, SellerApplicationStatus } from "../../common/requests/sellers/endpoints";
import type { Tone } from "../../ui";

export const APPLICATION_STATUS: Record<SellerApplicationStatus, { label: string; tone: Tone }> = {
  pending: { label: "Pending", tone: "warning" },
  approved: { label: "Seller", tone: "success" },
  no_account: { label: "No account", tone: "outline" },
};

/** "To review" hides approved applications (no_account still needs action). */
export const visibleApplications = (apps: SellerApplication[], filter: "pending" | "all") =>
  filter === "pending" ? apps.filter((a) => a.status !== "approved") : apps;

export const pendingCount = (apps: SellerApplication[] | null | undefined) =>
  apps ? apps.filter((a) => a.status === "pending").length : null;
